'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_patterns_ServiceIcon_constants = require('../ServiceIcon/constants.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const serviceIcon = "_service-icon_1qej2_1";
const styles = {
	serviceIcon: serviceIcon
};

const ServiceIconShell = ({ children, hasBorder = true, hasShadow = false, hasWhiteBackground = false, size }) => {
  return React__default.default.createElement("span", { className: styles.serviceIcon, "data-border": hasBorder, "data-shadow": hasShadow, "data-background": hasWhiteBackground ? "white" : "default", "data-size": size, "data-zds": true, "data-testid": "ServiceIconShell", style: {
    "--width": components_patterns_ServiceIcon_constants.ServiceIconConfig[size].width,
    "--height": components_patterns_ServiceIcon_constants.ServiceIconConfig[size].width,
    "--border-radius": components_patterns_ServiceIcon_constants.ServiceIconConfig[size].borderRadius
  } }, children);
};

exports.ServiceIconShell = ServiceIconShell;
//# sourceMappingURL=ServiceIconShell.cjs.js.map
